<template>
  <GfrDropdown class="inline-flex ml-4 max-lg:ml-2 rtl:ml-0 rtl:mr-4 rtl:max-lg:mr-2">
    <GfrDropdownTrigger
      class="w-9 h-9 text-light transition-colors duration-200 rounded-full bg-dark-background flex items-center justify-center max-lg:w-6 max-lg:h-6 data-[state=open]:text-primary data-[state=close]:hover:text-primary-hover"
    >
      <IconsUsedName class="h-5 w-5 max-lg:h-4 max-lg:w-4" />
    </GfrDropdownTrigger>
    <GfrDropdownContent
      :offset-x="-6"
      :offset-y="8"
      placement="bottom-start"
      type="arrow"
      wrapper-class="z-20"
      class="drop-down-content-custom shadow-md"
      @open="resetScroll = true"
    >
      <div class="drop-down-title">
        <span class="drop-down-title-text">
          {{ formatTransify('UGC_OFFICIAL_WEBSITE_USED_NAME') }}
        </span>
      </div>
      <GfrScrollArea
        v-model:reset="resetScroll"
        class="drop-down-ul"
        :dir="$route.params.lang === 'ar' ? 'rtl' : 'ltr'"
      >
        <ul>
          <li v-for="(item, index) in usedNames" :key="index" class="">
            {{ item }}
          </li>
        </ul>
      </GfrScrollArea>
    </GfrDropdownContent>
  </GfrDropdown>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
defineProps({
  usedNames: {
    type: Array as PropType<string[]>,
    default: () => []
  }
})
const store = useStore()
const { formatTransify } = store
const resetScroll = ref(false)
</script>

<style lang="scss">
.drop-down-content-custom {
  @apply rounded-[2px] bg-dark-background w-fit min-w-[236px] max-lg:min-w-40;
  // @apply after:content-[""] after:w-2 after:h-2 after:absolute after:bg-dark-background after:-top-1 after:left-0 after:-rotate-45;
}

.drop-down-title {
  @apply h-8 w-full px-4 text-m-p leading-8 text-light font-bold border-b-[1px] border-[#f0f0f0]/[10%];
  @apply max-lg:px-2 max-lg:h-6.5 max-lg:text-m-mini max-lg:leading-6.5;
  .drop-down-title-text {
    @apply w-full h-full line-clamp-1 text-ellipsis;
  }
}

.drop-down-ul {
  @apply px-4 py-3 w-full max-h-[90px] max-lg:p-2 max-lg:max-h-20;

  li {
    @apply w-full h-5.5 text-m-p max-lg:text-m-mini text-white relative mb-0.5 flex px-5 max-lg:px-3;
    @apply before:flex-shrink-0 before:content-[''] before:top-2.5 before:bg-white before:relative before:h-1 before:w-1 before:rounded-[1px] ltr:before:-left-2.5 rtl:before:-right-2.5;
    @apply max-lg:before:-left-2 max-lg:before:h-0.5 max-lg:before:w-0.5;
  }
}
</style>
